// extracted by mini-css-extract-plugin
module.exports = {"customContents":"BottomSheetCustomContents_customContents__2rp9E"};